export const SCOPE = 'read:current_user update:current_user_metadata';
